import * as React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router';
import Image from '../../atoms/Image';

import logo from './logo.png';
import styles from './Navbar.module.scss';

export interface Props extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode;
}

/**
 * <Navbar> component
 */
export const Navbar: React.FunctionComponent<Props> = ({
  className,
  children,
  ...htmlElementProps
}) => (
  <nav className={classNames(styles.navbar, className)} {...htmlElementProps}>
    <div className="container">
      <Link to="/">
        <Image src={logo} alt="Logo Quality 24" />
      </Link>

      <div className={styles.menu}>{children}</div>
    </div>
  </nav>
);

export default Navbar;
